import { getAuthHeaders } from "@/features/auth";
import type { MeetingNote } from "../types/note";

/**
 * Synchronizes the updated meeting notes array to the backend database.
 * Calls PATCH /meeting/notes
 */
export async function updateMeetingNotes(
  translatorServiceUrl: string,
  meetingId: string | number,
  notes: MeetingNote[]
): Promise<void> {
  const authHeaders = await getAuthHeaders();
  const cleanedUrl = translatorServiceUrl.replace(/\/$/, "");
  const res = await fetch(`${cleanedUrl}/meeting/notes`, {
    method: "PATCH",
    headers: {
      ...authHeaders,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      meeting_id: meetingId,
      notes,
    }),
  });

  if (!res.ok) {
    throw new Error(`Failed to update meeting notes: ${res.status}`);
  }
}
